import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IManager } from "../../../interfaces/IManager";
import { IFixPersonToManager } from "../../../interfaces/store/slices/listAgentSlice";
import { IManagerFormDefaultValues } from "../../../interfaces/AdminManagerInfo/IManagerFormDefaultValues";
import { IManagerState } from "../../../interfaces/store/slices/managerSlice/IManagerState";

const initialState: IManagerState = {
  currentManager: null,
  isEditForm: false,
};

const managerSlice = createSlice({
  name: "managerInfo",
  initialState,
  reducers: {
    setManager(state, action: PayloadAction<IManager>) {
      state.currentManager = action.payload;
    },
    clearManager(state) {
      state.currentManager = null;
      state.isEditForm = false;
    },
    attachPersonToManager(
      state,
      action: PayloadAction<{
        personType: string;
        personData: IFixPersonToManager;
      }>,
    ) {
      const { personType, personData } = action.payload;
      if (!state.currentManager) return;

      if (personType === "client") {
        state.currentManager.clients = [
          ...(state.currentManager.clients || []),
          personData,
        ];
      }

      if (personType === "agent") {
        state.currentManager.agents = [
          ...(state.currentManager.agents || []),
          personData,
        ];
      }
    },
    detachPersonFromManager(
      state,
      action: PayloadAction<{
        personType: "agent" | "client";
        personId: number;
      }>,
    ) {
      if (state.currentManager) {
        if (action.payload.personType === "agent") {
          state.currentManager.agents = state.currentManager.agents.filter(
            (el) => el.id !== action.payload.personId,
          );
        }

        if (action.payload.personType === "client") {
          state.currentManager.clients = state.currentManager?.clients?.filter(
            (el) => el.id !== action.payload.personId,
          );
        }
      }
    },
    editMainManagerInfo(
      state,
      action: PayloadAction<IManagerFormDefaultValues>,
    ) {
      if (state.currentManager) {
        state.currentManager = { ...state.currentManager, ...action.payload };
      }
    },
    setIsEditForm(state, action: PayloadAction<boolean>) {
      state.isEditForm = action.payload;
    },
    blockManager(state) {
      if (state.currentManager) {
        state.currentManager.is_banned = true;
      }
    },
    archiveManager(state) {
      if (state.currentManager) {
        state.currentManager.is_enabled = false;
      }
    },
  },
});

export const {
  setManager,
  clearManager,
  attachPersonToManager,
  detachPersonFromManager,
  setIsEditForm,
  editMainManagerInfo,
  blockManager,
  archiveManager,
} = managerSlice.actions;
export default managerSlice.reducer;
